import React, {useContext} from "react";
import "./Contact.scss";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import {illustration, contactInfo, greeting} from "../../portfolio";
import Reveal from "../../components/reveal/Reveal";
import email from "../../assets/lottie/email";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import StyleContext from "../../contexts/StyleContext";

const toWhatsAppUrl = phone => {
  const digits = phone.replace(/\D/g, "");
  const normalized = digits.startsWith("0")
    ? `92${digits.slice(1)}`
    : digits.startsWith("92")
    ? digits
    : `92${digits}`;
  return `https://wa.me/${normalized}`;
};

const toGmailUrl = address =>
  `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(address)}`;

export default function Contact() {
  const {isDark} = useContext(StyleContext);
  const whatsAppUrl = contactInfo.number
    ? toWhatsAppUrl(contactInfo.number)
    : null;
  const gmailUrl = toGmailUrl(contactInfo.email_address);

  return (
    <Reveal direction="up">
      <div className="main contact-margin-top" id="contact">
        <div className="contact-div-main reveal-stagger">
          <div className="contact-header" style={{"--i": 0}}>
            <span className="section-eyebrow">Let&apos;s talk</span>
            <h1 className="heading contact-title">Get in touch</h1>
            <p
              className={
                isDark ? "contact-subtitle" : "subTitle contact-subtitle"
              }
            >
              {contactInfo.subtitle}
            </p>
            <div className={isDark ? "contact-text-div" : "contact-text-div"}>
              {contactInfo.number && whatsAppUrl && (
                <a
                  className="contact-detail"
                  href={whatsAppUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Message on WhatsApp: ${contactInfo.number}`}
                >
                  <i className="fab fa-whatsapp" aria-hidden="true" />
                  <span>{contactInfo.number}</span>
                </a>
              )}
              <a
                className="contact-detail-email"
                href={gmailUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Open Gmail to email ${contactInfo.email_address}`}
              >
                <i className="fas fa-envelope" aria-hidden="true" />
                <span>{contactInfo.email_address}</span>
              </a>
              {contactInfo.address && (
                <span className="contact-detail">
                  <i className="fas fa-map-marker-alt" aria-hidden="true" />
                  <span>{contactInfo.address}</span>
                </span>
              )}
              <div className="contact-actions">
                <Button
                  text="Send email"
                  href={gmailUrl}
                  newTab={true}
                />
                {greeting.resumeLink && (
                  <a
                    href={greeting.resumeLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-resume-link"
                  >
                    Download resume →
                  </a>
                )}
              </div>
              <div className="contact-social">
                <SocialMedia />
              </div>
            </div>
          </div>
          <div className="contact-image-div" style={{"--i": 1}}>
            <div className="lottie-frame">
              {illustration.animated ? (
                <DisplayLottie animationData={email} speed={2.2} />
              ) : (
                <img
                  alt="Contact illustration"
                  src={require("../../assets/images/contactMailDark.svg")}
                />
              )}
            </div>
            <div className="contact-pulse-badge" aria-hidden="true">
              <span className="contact-pulse-dot" />
              Reply within 24h
            </div>
          </div>
        </div>
      </div>
    </Reveal>
  );
}
